import React from 'react'
import {Form, Input, Button} from 'antd'
import RegisterSteps from './register_steps'
import {UserOutlined, LockOutlined, MailOutlined} from '@ant-design/icons'
import API from 'api'
import {useEffect} from 'react'
import {useHistory} from 'react-router-dom'
import {useState} from 'react'
import {newUser, User} from 'api/user'

const emailRules = [
  {
    message: '请输入正确的邮箱地址',
    pattern: /^\w+@[a-zA-Z0-9]{2,10}(?:\.[a-z]{2,4}){1,3}$/,
  },
]

const passwordRules = [
  {
    min: 8,
    message: '长度至少为8个字符',
  },
]

const confirmPasswordRules = [
  ({getFieldValue}) => ({
    validator(_, value) {
      if (!value || getFieldValue('newPassword') === value) {
        return Promise.resolve()
      }
      return Promise.reject(new Error('请输入相同的密码'))
    },
  }),
]

const EditUserInfoCom = () => {
  const history = useHistory()
  const [user, setUser] = useState<User>(newUser())
  useEffect(() => {
    let user = (history.location.state as any).user
    setUser(user)
    userInfoForm.setFieldsValue({
      nickname: user.nickname,
      email: user.email,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const [userInfoForm] = Form.useForm()
  const editUserInfo = values => {
    let role = {detail: '', domain: 'course'}
    let detail: any[] = []
    for (let i = 0; i < 3; i++) {
      detail.push({
        module: i + 7,
      })
    }
    role.detail = JSON.stringify(detail)
    values.action = 'setPassword'
    if (values.newPassword !== undefined) {
      values.password = values.newPassword
    }
    values.user = {
      ...user,
      nickname: values.nickname,
      email: values.email,
      roles: [role],
    }
    delete values.newPassword
    delete values.queryPassword
    delete values.nickname
    delete values.email

    API.editUserInfo(values).then(res => {
      if (res.code === 200) {
        history.push('/register/success')
      }
    })
  }
  return (
    <>
      <RegisterSteps current={1} />
      <Form form={userInfoForm} onFinish={editUserInfo}>
        <Form.Item name="newPassword" rules={passwordRules}>
          <Input.Password
            size="large"
            placeholder="设置密码"
            className="login-input"
            prefix={<LockOutlined style={{color: '#BFBFBF'}} />}
          />
        </Form.Item>
        <Form.Item name="queryPassword" dependencies={['newPassword']} rules={confirmPasswordRules}>
          <Input.Password
            size="large"
            placeholder="确认密码"
            className="login-input"
            prefix={<LockOutlined style={{color: '#BFBFBF'}} />}
          />
        </Form.Item>
        <Form.Item>
          <div className="register-form-item">默认密码：12345678</div>
        </Form.Item>
        <Form.Item name="nickname">
          <Input
            size="large"
            placeholder="昵称"
            className="login-input"
            prefix={<UserOutlined style={{color: '#BFBFBF'}} />}
          />
        </Form.Item>
        {/* <Form.Item name="org">
          <Input
            size="large"
            placeholder="所在学校"
            className="login-input"
            prefix={<HomeOutlined style={{color: '#BFBFBF'}} />}
          />
        </Form.Item> */}
        <Form.Item name="email" rules={emailRules}>
          <Input
            size="large"
            placeholder="邮箱地址"
            className="login-input"
            prefix={<MailOutlined style={{color: '#BFBFBF'}} />}
          />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            className="login-form-button"
            style={{marginTop: 32}}
          >
            注册
          </Button>
        </Form.Item>
      </Form>
    </>
  )
}

export default EditUserInfoCom
